import type { AppDispatch } from '@shared/store';
import { UIActions } from '@shared/store/ui/ui';
import {
  MdcSnackbarFixedPosition,
  MdcSnackbarFloatingPosition,
  MdcSnackbarSeverities,
  MdcSnackbarVariants
} from 'ids-wc/dist/types/components';
import { useDispatch } from 'react-redux';

export interface ShowSnackbarOptions {
  messageTitle?: string;
  message: string;
  severity: MdcSnackbarSeverities;
  variant?: MdcSnackbarVariants;
  fixedPosition?: MdcSnackbarFixedPosition;
  floatingPosition?: MdcSnackbarFloatingPosition;
  icon?: string;
  duration?: number;
}

export const useSnackbar = () => {
  const dispatch = useDispatch<AppDispatch>();

  const showSnackbar = (options: ShowSnackbarOptions) => {
    dispatch(UIActions.showSnackbar(options));
  };

  const showSuccess = (message: string, messageTitle?: string) => {
    showSnackbar({ message, messageTitle, severity: 'successDark', icon: 'check' });
  };

  const showError = (message: string, messageTitle?: string) => {
    showSnackbar({ message, messageTitle, severity: 'error', icon: 'info' });
  };

  const showWarning = (message: string, messageTitle?: string) => {
    showSnackbar({ message, messageTitle, severity: 'warning', icon: 'warning' });
  };

  const showInfo = (message: string, messageTitle?: string) => {
    showSnackbar({ message, messageTitle, severity: 'info', icon: 'info' });
  };

  const clearAllSnackbars = () => {
    dispatch(UIActions.clearAllSnackbars());
  };

  return {
    showSnackbar,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearAllSnackbars
  };
};
